import { Route, Routes } from "react-router-dom";
import styled from "styled-components";
import DownloadPage from "pages/DownloadPage";
import SoftwarePage from "pages/SoftwarePage";
import SignupPage from "pages/SignupPage";
import VerifyUserPage from "pages/VerifyUser/VerifyUser";
import VerifyUserCompletePage from "pages/VerifyUser/VerifyUserComplete";
import LoginPage from "pages/Login";
import ActivationPage from "pages/ActivationPage";
import SignupCompletePage from "pages/SignupCompletePage";
import ResetPage from "pages/ResetPage";
import ResetCompletePage from "pages/ResetPage/ResetComplete";
import ChangePasswordPage from "pages/ProfilePage/ChangePassword";
import ProfilePage from "pages/ProfilePage";
import TrialPage from "pages/TrialPage";
import OptinCompletePage from "pages/OptinCompletePage";

const AppRouter: React.FC = () => (
  <BaseDiv>
    <Routes>
      <Route path="download" element={<DownloadPage />} />
      <Route path="software" element={<SoftwarePage />} />
      <Route path="activation" element={<ActivationPage />} />
      <Route path="trial" element={<TrialPage />} />
      <Route
        path="signup"
        element={<SignupPage completeTo="/signup/complete" />}
      />
      <Route path="signup/complete" element={<SignupCompletePage />} />
      <Route path="verifyUser" element={<VerifyUserPage />} />
      <Route path="verifyUser/complete" element={<VerifyUserCompletePage />} />
      <Route path="optin" element={<OptinCompletePage />} />
      <Route
        path="reset"
        element={<ResetPage completeTo="/reset/complete" />}
      />
      <Route path="reset/complete" element={<ResetCompletePage />} />
      <Route path="profile" element={<ProfilePage />} />
      <Route path="profile/changePassword" element={<ChangePasswordPage />} />
      <Route path="/" element={<LoginPage />} />
    </Routes>
  </BaseDiv>
);

const BaseDiv = styled.div``;

export default AppRouter;
